module.exports = __webpack_public_path__ + "static/img/login_download_platform.e8aa590.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/login_download_platform.svg
// module id = /pPS
// module chunks = 4